<template>
  <div>
    <h1 class="page-header">{{ $t('examschedule.examSchedule') }}</h1>
    <div class="row">
      <div
        v-show="isStaff"
        class="col-md-3 col-sm-12"
        :class="{ 'col-lg-3': isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        class="col-lg-9 col-md-9 col-sm-12"
        :class="{ 'col-lg-12': !isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <div
              class="d-flex flex-wrap justify-content-between align-items-center"
            >
              <div class="mb-2 mb-sm-0"></div>
              <div
                class="d-flex align-items-center w-100 w-sm-auto justify-content-end flex-grow-1 flex-sm-grow-0"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px;"
                  class="kh-font flex-grow-1 flex-sm-grow-0"
                />
                <ts-button
                  outline
                  class="ml-2 flex-shrink-0"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table
            :columns="columns"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'acps_name_foreign'
            }"
          >
            <template v-slot="{ record }">
              <td>{{ record.exam_name }}</td>
              <td>{{ record.start_date }}</td>
              <td>{{ record.end_date }}</td>
              <td class="text-center">
                <span
                  v-if="record.status === 'expired' || record.is_expired"
                  class="badge badge-secondary"
                >
                  {{ $t('pickupCardCreation.expired') || 'Expired' }}
                </span>
                <span v-else class="badge badge-success">
                  {{ $t('active') || 'Active' }}
                </span>
              </td>
              <td>
                {{ $store.getters.limitStringShow(record.exam_criteria, 55) }}
              </td>
              <td class="text-center">
                <a
                  v-show="isStaff"
                  href="#"
                  title="edit"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  v-show="isStaff"
                  href="#"
                  title="delete"
                  class="text-danger"
                  @click.prevent="destroy(record.exam_sch_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <a-drawer
        :title="$t('filter')"
        placement="right"
        :closable="true"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        :width="drawerWidth"
      >
        <div class="row">
          <div class="col-md-12">
            <!-- Active Status -->
            <div class="form-group">
              <label>{{ $t('status') || 'Status' }}</label>
              <a-select v-model="active_status" style="width: 100%">
                <a-select-option value="active">{{
                  $t('active') || 'Active'
                }}</a-select-option>
                <a-select-option value="expired">{{
                  $t('pickupCardCreation.expired') || 'Expired'
                }}</a-select-option>
                <a-select-option value="all">{{
                  $t('all') || 'All'
                }}</a-select-option>
              </a-select>
            </div>

            <!-- Date range -->
            <div class="form-group">
              <label>{{ $t('event.dateRange') || 'Date Range' }}</label>
              <a-range-picker
                v-model="date_range"
                style="width: 100%"
                format="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>

<script>
import { debounce, isEmpty } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'exam-schedule',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      student_id: null,
      route_leave: false,
      active_status: 'active',
      date_range: [],
      visible: false,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
      columns: [
        { name: this.$t('examschedule.name'), style: 'width: 20%;' },
        { name: this.$t('examschedule.startdate'), style: 'width: 12%;' },
        { name: this.$t('examschedule.enddate'), style: 'width: 12%;' },
        {
          name: this.$t('status') || 'Status',
          style: 'width: 10%; text-align:center'
        },
        { name: this.$t('examschedule.criteria') },
        {
          name: this.$t('examschedule.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    if (this.isParent) {
      this.student_id = this.$store.state.selectedStudent.student_id
    }
    if (this.isStudent) {
      this.student_id = this.$store.state.home.student.profile.student_id
    }
    if (this.isStaff || this.isTeacher) {
      this.fetchData()
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapState('examSchedule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.examSchedule.search
      },
      set(newVal) {
        this.$store.commit('examSchedule/SET_SEARCH', newVal)
        this.$store.commit('examSchedule/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    isStudent() {
      return this.$store.getters.isStudentLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    },
    drawerWidth() {
      return this.windowWidth < 576 ? '85%' : '320px'
    },
    from_date() {
      return this.date_range && this.date_range[0]
        ? this.date_range[0].format('YYYY-MM-DD')
        : undefined
    },
    to_date() {
      return this.date_range && this.date_range[1]
        ? this.date_range[1].format('YYYY-MM-DD')
        : undefined
    },
    filters() {
      return {
        active_status: this.active_status,
        from_date: this.from_date,
        to_date: this.to_date,
        student_id: this.student_id
      }
    }
  },
  methods: {
    handleResize() {
      if (typeof window !== 'undefined') {
        this.windowWidth = window.innerWidth
      }
    },

    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'examSchedule/fetch',
          Object.assign({}, this.filters, { ...attributes })
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/exam-schedules/${data.exam_sch_id}`)
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('examSchedule/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    filters: {
      deep: true,
      handler: debounce(function() {
        this.$store.commit('examSchedule/RESET_CURRENT_PAGE')
        this.fetchData()
      }, 500)
    },
    student_id: debounce(function(value) {
      this.fetchData({ student_id: value })
    }, 500),
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.student_id = null
        this.student_id = this.$store.state.selectedStudent.student_id
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (isEmpty(to.params) && to.name != 'exam-schedule-create') {
      this.$store.commit('examSchedule/RESET_STATE')
      this.$store.commit('examSchedule/SET_SUB_PROGRAMS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
